import _objectSpread2 from '../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import '../../node_modules/core-js/modules/web.dom-collections.iterator.js';
import { forwardRef, useState, useEffect } from 'react';
import { useLocalRef } from '../../hooks/useLocalRef.js';
import { block } from '../../utils/block.js';
import { limitIndexToRange } from '../../utils/common.js';
import './Dropdown.scss.js';
import { jsx } from 'react/jsx-runtime';

const _excluded = ["children", "isOpen", "className", "onKeyDown"];
const b = block('dropdown');
const DropdownList = /*#__PURE__*/forwardRef(function DropdownList(_ref, ref) {
  let {
      children,
      isOpen,
      className = '',
      onKeyDown
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    localRef,
    localRefFunction
  } = useLocalRef(ref);
  const [focusIndex, setFocusIndex] = useState(-1);
  useEffect(() => {
    if (isOpen) {
      setFocusIndex(0);
    } else {
      setFocusIndex(-1);
    }
  }, [isOpen]);
  const moveFocusIndex = e => {
    var _localRef$current;
    const range = ((_localRef$current = localRef.current) === null || _localRef$current === void 0 ? void 0 : _localRef$current.children.length) || 1;
    switch (e.code) {
      case 'ArrowDown':
        {
          setFocusIndex(limitIndexToRange(focusIndex + 1, range));
          break;
        }
      case 'ArrowUp':
        {
          setFocusIndex(limitIndexToRange(focusIndex - 1, range));
          break;
        }
    }
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
  };
  useEffect(() => {
    var _localRef$current2, _localRef$current2$ch, _localRef$current2$ch2;
    (_localRef$current2 = localRef.current) === null || _localRef$current2 === void 0 ? void 0 : (_localRef$current2$ch = _localRef$current2.children) === null || _localRef$current2$ch === void 0 ? void 0 : (_localRef$current2$ch2 = _localRef$current2$ch[focusIndex]) === null || _localRef$current2$ch2 === void 0 ? void 0 : _localRef$current2$ch2.focus();
  }, [focusIndex]);
  return /*#__PURE__*/jsx("ul", _objectSpread2(_objectSpread2({
    className: b('list').mix(className),
    "aria-expanded": isOpen,
    ref: localRefFunction,
    onKeyDown: moveFocusIndex
  }, props), {}, {
    children: children
  }));
});
DropdownList.displayName = 'DropdownList';

export { DropdownList };
